var exports = {
  "k": "xa15a2ab7--e98e60--container",
};

module.exports = exports;
